import { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { useNavbar } from "../../context/NavBarContext";
import UserProfile from "../common/UserProfile";

export interface UserJson {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  imageId: string;
}

function Header() {
  const userJson = localStorage.getItem("user");
  const [user, setUser] = useState<UserJson>();
  const { isOpen, toggleNavbar } = useNavbar();

  useEffect(() => {
    if (userJson) {
      setUser(JSON.parse(userJson));
    }
  }, [userJson]);

  return (
    <div className="w-full h-auto flex justify-between">
      <div className="flex gap-4 items-center xl:hidden">
        <GiHamburgerMenu
          color="#C34A25"
          size={18}
          onClick={() => toggleNavbar(!isOpen)}
        />
        <p className="text-lg font-normal leading-6 self-center">
          {`สวัสดี คุณ ${user?.firstName} ${user?.lastName} 👋🏻`}
        </p>
      </div>
      <p className="text-lg font-normal leading-6 self-center hidden xl:block">
        {`สวัสดี คุณ ${user?.firstName} ${user?.lastName} 👋🏻`}
      </p>
      <UserProfile user={user} />
    </div>
  );
}

export default Header;
